import CityPageTemplate from "../city-template/CityPageTemplate";
import { landerConfig } from "./data";

export default function LanderPage() {
  return <CityPageTemplate config={landerConfig} />;
}